import React, { useEffect, useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Icons from "../../assets/icons/index";
import Images from "../../assets/images/index";
import { auth, firebaseData } from "../../firebase";
import { toast, ToastContainer } from 'react-toastify';
import { getCountryStateCityData, getCountryStateCityList, getCurrent, Register } from "../../restApi/api";
import { decrypt, decryptdata, encrypt, encryptdata } from "../../utils/crypto";
import { signInWithPhoneNumber } from "firebase/auth";
import { getAnalytics, setUserId, setUserProperties } from 'firebase/analytics';
import Loader from "../common/Loader/Loader";
import moment from "moment";
const INITIAL_STATE = {
    name: null,
    email: null,
    country: "",
    collegeCity: "",
    collegeName: "",
    collegeYear: "",
    collegeState: "",
    avatar: "",
    batch:"",
    preparingFor:'',
    mobileNo:'',
    otpOrderNumber: "",
    countryCode: "",
    role: 'User',
    deviceType:'website',
    deviceModelNo: '',
    deviceVersion:11,
    deviceId:'',

};
export default function SignUp() {
    let [loader,setloader]=useState(false)
    const [config, setConfig] = useState();
    const [remoteLoading, setRemoteLoading] = useState(true);
    const navigate = useNavigate();
    const [hasClass, setHasClass] = useState();
    const [hasClass2, setHasClass2] = useState();
    const [hasClass1, setHasClass1] = useState();
    const [hasClass3, setHasClass3] = useState();
    const [showstate,setStateSelect]=useState(true)
    const [showcity,setCitySelect]=useState(true)
    const [showcollege,setCollegeSelect]=useState(true)
    const [showcollegeyear,setCollegeyearSelect]=useState(true)
    const [showbatch,setBatchSelect]=useState(true)

    const [show_1, showForm] = useState(true);
    const [show_2, showFormSecond] = useState(false);
    const [show_3, showFormThird] = useState(false)
    const [showcheck, showchecked] = useState(true)
    const [term, showTerm] = useState(false)
    const [errors, setErrors] = useState({});
    const [country, setCountry] = useState(null);
    const [state, setState] = useState(null);
    const [city, setCity] = useState(null);
    const [college, setCollege] = useState(null);
    const [collegeYear, setCollegeYear] = useState(null);
    const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
    const [countryId, setcountryId] = useState(null);
    const [cityId, setCityId] = useState(null);
    const [stateId, setStateId] = useState(null);
    const [file, setFile]= useState("");
    const [browserName, showBrowserName] = useState('');
    const [device, showDevice] = useState(null);
    
      useEffect(() => {
          getCountry()
          const getConfigData = async () => {
            try {
              const remoteData = await firebaseData('settings_config'); // Replace 'your_config_key' with the actual key for the configuration value you want
              setConfig(JSON.parse(remoteData));
              setRemoteLoading(false);
            } catch (error) {
              console.error('Error fetching remote data:', error);
              setRemoteLoading(false);
            }
          };
      
          if (typeof window !== 'undefined') {
            getConfigData();
          }
          
        }, []);

        useEffect(()=>{
          document.body.className = 'signup';
          return () => { document.body.className = ''; }

      },[])
      useEffect(()=>{
        countryId && selectCountry()
    },[countryId])

    useEffect(()=>{
        stateId && selectState()
    },[stateId])

    useEffect(()=>{
        cityId && selectCity()
    },[cityId])
  
      const firebaseStore=async(data)=>{
		let activePackageList = data.activePackage
        let sizeOfActiveList = activePackageList.length
		let activePackage=[]
		for(let i=0;i<sizeOfActiveList;i++){
		    activePackage.push(data.activePackage[i].packageId)
		}
		let paid
		if (sizeOfActiveList > 0){
			paid=true
		}else{
			paid=false
		}
		var noOfDays = 0
		if(data.trialEndDate){
            let end_Date= moment(new Date())
			let start_Date = moment(data.trialEndDate); // add date in the yy / mm / dd format.
            noOfDays = end_Date.diff(start_Date, 'days');
		}else{
			noOfDays= 0
		}
		const analytics = getAnalytics()
			setUserId(analytics,data._id);
			setUserProperties(analytics, 
				{ 
					user_id:data._id,
					name: data.name ,
					isNotification:data.isNotification,
					email:data.email,
					mobileNo:data.mobileNo,
					createdAt:data.createdAt,
					Version:data.version,
					countryCode:data.countryCode,
					Year:data.batch.year,
					country:data.address.country,
					collegeState:data.address.collegeState,
					collegeCity:data.address.collegeCity,
					collegeName:data.address.collegeName,
					course:data.preparingFor,
					collegeYear:data.collegeYear,
					isFreeTrialActivated:noOfDays>0?true:false,
					packages:activePackage,
					paidUser:paid,
					role:data.role,
					trialEndDate:data.trialEndDate
				}
				);
    }
    const versionSelect=(data)=>{
        localStorage.setItem('version',JSON.stringify(data))
      }

      const languageSelect=(data)=>{
        localStorage.setItem('language',JSON.stringify(data))
      }

	const currentList=async ()=>{
        await getCurrent()
        .then(response => {
          return response.json()
        })
        .then(data => {
           let req= JSON.parse(decrypt(data))
            let user=req.data.result
            let profileDetails={
                id:user._id,
                name: user.name,
                avatar : user.avatar,
                country:user.address.country,
                email: user.email,
                collegeCity:user.address.collegeCity,
                collegeName:user.address.collegeName,
                collegeState:user.address.collegeState,
                collegeYear:user.collegeYear,
                batch:user.batch._id,
                mobileNo: user.mobileNo,
                preparingFor:user.preparingFor
            };
			firebaseStore(req.data.result)
            localStorage.setItem('profileDetails',encrypt(JSON.stringify(profileDetails)))
            const packageStatus = JSON.stringify({ activePackageLength: user.activePackage.length, isTrialUser: user.isTrialUser })
            localStorage.setItem('packageStatus', encrypt(packageStatus))
			let version=[]
			config && config?.courses.map(o=>{
                if(o.title===user.preparingFor){
                    version=o.versions
					return
				}
            })
            setloader(false)
			languageSelect('English')
		    versionSelect(version[0])
            navigate('/videolayer')
        }).catch((error) => {
            setloader(false)
        })
    }
     
// ----->GetDevice Id Function--------//
const getDeviceId=()=>{
    let did= decryptdata(localStorage.getItem('dId'))
    if(did !== undefined && 
       did !== ""  &&
       did!==null && 
       did !== "null"){
       let deviceId=did
       showDevice(deviceId)
        return
    }
      let r = (Math.random() + 1).toString(36).substring(2);
    //  let deviceId = Date.now().toString()+r;
    let deviceId = '1692972505820sxmhipzu0m'
     showDevice(deviceId)
      return  
  }

      const getCountry=async ()=>{
		const data = {
		  "country":"",
		  "state": "",
		  "city": "",
		  "courses" :  getProfileDetails?.preparingFor
		}
        await getCountryStateCityData(data)
        .then(response => {
          return response.json()
        })
        .then(data => {
            setCountry(data)
            setState(null)
            setCity(null)
            setCollege(null)
        })
    }

    const selectCountry=async (slctCountry)=>{
        profileDetails({
            ...getProfileDetails,
            country : slctCountry?slctCountry.target.value:countryId
    })
		const data = {
		  "country":slctCountry?slctCountry.target.value:countryId,
		  "state": "",
		  "city": "",
		  "courses" :  getProfileDetails?.preparingFor
		}
        await getCountryStateCityList(data)
        .then(response => {
            return response.json()
        })
        .then(data => {
            // setStateId(data&&data.data.result.states[0]._id)
            if(data.data.result?.states){
                setState(data)
                setCity(null)
                setCollege(null)
                setStateSelect(false)
                setCitySelect(true)
                setCollegeSelect(true)
                return
                }
                setState(null)
                setCity(null)
                setCollege(null)
                setStateSelect(true)
                setCitySelect(true)
                setCollegeSelect(true)
                return
           

        })
    }

    const selectState=async (slctState)=>{
        profileDetails({
            ...getProfileDetails,
            collegeState : slctState?slctState.target.value:stateId
    })
		const data = {
		  "country":"",
		  "state": slctState?slctState.target.value:stateId,
		  "city": "",
		  "courses" :  getProfileDetails?.preparingFor
		}
        await getCountryStateCityList(data)
        .then(response => {
          return response.json()
        })
        .then(data => {
            if(data.data.result?.city){
                setCitySelect(false)
                setCollegeSelect(true)
                setCity(data)
                setCollege(null)
                return
                }
                setCitySelect(true)
                setCollegeSelect(true)
                setCity(null)
                setCollege(null)
                return
        })
    }

    const selectCity=async (slctCity)=>{
        profileDetails({
            ...getProfileDetails,
            collegeCity : slctCity?slctCity.target.value:cityId
    })
		const data = {
		  "country":"",
		  "state": "",
		  "city": slctCity?slctCity.target.value:cityId,
		  "courses" :  getProfileDetails?.preparingFor
		}
        await getCountryStateCityList(data)
        .then(response => {
          return response.json()
        })
        .then(data => {
            if(data.data.result?.colleges){
                setCollegeSelect(false)
                setCollegeyearSelect(false)
                setBatchSelect(false)
                setCollege(data)
                setCollegeYear(data)
                return
                }
                setCollegeSelect(true)
                setCollegeyearSelect(true)
                setBatchSelect(true)
                setCollege(null)
                setCollegeYear(null)
                return
        })
    }

    const handleInputChange = function (fieldValue, fieldName) {
        profileDetails({ ...getProfileDetails, [fieldName]: fieldValue })
  }
  const checkbox = async(e,data)=> {

    showchecked(e.target.checked)

    // console.log(e.target.checked, "checked");
      if(e.target.checked){
        handleInputChange(data,'preparingFor')
      }
      else{
        handleInputChange('','preparingFor')
      }
   }

  const setAvatar = async (e) => {
    const selectedFile = e[0];
    
    if (selectedFile && (selectedFile.type === 'image/png' || selectedFile.type === 'image/jpeg'||selectedFile.type === 'image/jpg')) {
        profileDetails({
            ...getProfileDetails,
            avatar: e[0],
        });
        setFile(URL.createObjectURL(e[0]))            
    } else {
      // Display an error message or take appropriate action
    toast.error('Please select a PNG or JPG image.');
    }
     
  }

  const termAndCondition= async(e)=>{
      getDeviceId()
      getBrowserDetails()
      showTerm(e.target.checked)
  }

  const getBrowserDetails=()=>{ 
    let browser  
    let userAgent = navigator.userAgent;            
        if(userAgent.match(/chrome|chromium|crios/i)){
            browser="chrome"
          }else if(userAgent.match(/firefox|fxios/i)){
            browser("firefox")
          }  else if(userAgent.match(/safari/i)){
            browser="safari"
          }else if(userAgent.match(/opr\//i)){
            browser="opera";
          } else if(userAgent.match(/edg/i)){
            browser="edge";
          }else{
          browser="No browser detection"
          }
    showBrowserName(browser)   
  }

    const handleSubmit = async (e) => {
      setloader(true)
    e.preventDefault();
//    let value= decryptdata(localStorage.getItem('data'))
   let data= JSON.parse(localStorage.getItem('data'))
    let formData = new FormData();
      formData.append("name", getProfileDetails.name);
      formData.append("email", getProfileDetails.email);
      formData.append("country", getProfileDetails.country);
      formData.append("collegeCity", getProfileDetails.collegeCity);
      formData.append("collegeName", getProfileDetails.collegeName);
      formData.append("collegeState", getProfileDetails.collegeState);
      formData.append("collegeYear", getProfileDetails.collegeYear);
      formData.append("mobileNo", data.mobile);
      formData.append("countryCode",'+'+data.dial);
      formData.append("otpOrderNumber", data.otpOrder);
      formData.append("batch", getProfileDetails.batch);
      formData.append("role", 'User');
      formData.append("deviceType", getProfileDetails.deviceType);
      formData.append("deviceModelNo", browserName);
      formData.append("deviceId", device);
      formData.append("deviceVersion", getProfileDetails.deviceVersion);
      formData.append("preparingFor", getProfileDetails.preparingFor);
      if(getProfileDetails.avatar?.name){
          formData.append('avatar',getProfileDetails.avatar)
      }

      const res = await Register(formData)
      .then(response => {
          return response.json()
        })
        .then(req => {
        //    let req= JSON.parse(decrypt(data))

            if (req.data.code == 1) {
                setloader(false)
                let value= encryptdata(req.data.result.Token)
                let did= encryptdata(device)
                localStorage.setItem('dId',did)
                localStorage.setItem('token',value)
                localStorage.removeItem('data')
                currentList()
            }
            else{
                setloader(false)
                toast.error(req.data.message)
            }
        }).catch((error) => {
            setloader(false)
      })
    }
        
        // Helper function to validate email format
        const isValidEmail = () => {
          // Regular expression for email validation
          const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          let data= emailRegex.test(getProfileDetails.email);
          if(data){
              return true
          }
          else{
            return false
          }
        };

        const validateName = () => {
            // Validate name field, return true if valid, false otherwise
            if(getProfileDetails.name){
                return true
            }
            else{
               return false
            }
          };

        const showToastError = (message) => {
        toast.error(message);
        };

        const nextButton =()=>{
        const isNameValid = validateName();
        const isEmailValid = isValidEmail();
        if(isEmailValid && isNameValid ){
            showForm(false)
            showFormThird(false)
            showFormSecond(true)
            setHasClass(true)
            setHasClass1(true)
        }
        else{
            if(isNameValid==false){
                showToastError('Please enter valid name')
            }
            if(isEmailValid==false){
                showToastError('Please enter valid email')
            }
        }
        }

        const nextButton1 =()=>{
            setHasClass2(true)
            setHasClass3(true)
            showForm(false)
            showFormSecond(false)
            showFormThird(true)
        }

        const backFunction =()=>{
            setHasClass(false)
            setHasClass1(false)
            showForm(true)
            showFormThird(false)
            showFormSecond(false)
        }

        const backFunction1 =()=>{
            setHasClass2(false)
            setHasClass3(false)
            showForm(false)
            showFormThird(false)
            showFormSecond(true)
        }
        
        let current1=false
        if(getProfileDetails.name!='' && getProfileDetails.email!='' && getProfileDetails?.name?.length>=3){
            current1=true
        }
        let current2=false
        if(getProfileDetails.preparingFor!=''){
            current2=true
        }
        let current3=false
        if(getProfileDetails.collegeCity!='' && getProfileDetails.collegeYear!='' && getProfileDetails.batch!='' &&getProfileDetails.collegeName && getProfileDetails.collegeState!='' && term!=false ){
            current3=true
        }
        if (loader) {return (<><Loader/></>)}

    return(
        <section className="signup_wrapper">
             <ToastContainer />
            <div className="register_container">
                <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <div className="stepper">
                            <ul type="none" className="stepper_child d-flex align-items-center">
                                <li className={`active ${hasClass?'step1_complete':''}`}><span className="step_1">Step 1</span></li>
                                <li className={`${hasClass1?'active':''} ${hasClass2?'step1_complete':''}`}>Step 2</li>
                                <li className={`${hasClass3?'active':''}`}><span className="step_3">Step 3</span></li>
                            </ul>
                            <div className="stepper_form">
                                <form onSubmit={(e) => { handleSubmit(e)}}>
                                {
                                    show_1 && (
                                        <div className="stepper_form_1">
                                            <div className="personal_ttl_form d-flex align-items-baseline">
                                                <figure className="back_arrow">
                                                    <Link to={'/onboarding/login'}>
                                                    <img src={Icons.BackArrow} alt="" className="img-fluid"/>
                                                    </Link>
                                                </figure>
                                                <div className="personal_ttl">
                                                    <h3>Personal Details</h3>
                                                    <p>Please Enter Required Details</p>
                                                </div>
                                            </div>
                                            <div className="form_submit_grp">
                                                    <div className="row">
                                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label htmlFor="">Full name*</label>
                                                                <input type="text" id="" style={{border:(getProfileDetails.name==''|| getProfileDetails?.name?.length<3 )?'1px solid red':''}} className="form-control" placeholder="Enter full name" required title="3 characters minimum" minLength={3} onChange={(e) => handleInputChange((e.target.value).trimStart(), 'name')} value={getProfileDetails.name}/>
                                                                {getProfileDetails?.name?.length<3 && getProfileDetails.name !== '' && (
                                                                <span style={{ color: '#DC3F16', fontSize: '12px' }}>Name must be atleast 3 characters*</span>
                                                                )}
                                                                {
                                                                getProfileDetails.name==''&&
                                                                <span style={{color: "#DC3F16", fontSize: "12px"}}>name is required*</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label htmlFor="">Email ID*</label>
                                                                <input type="text" id="" style={{border:getProfileDetails.email==''?'1px solid red':''}} className="form-control" placeholder="Enter email address" onChange={(e) => handleInputChange((e.target.value).trimStart(), 'email')} value={getProfileDetails.email}/>
                                                                {
                                                                getProfileDetails.email==''&&
                                                                <span style={{color: "#DC3F16", fontSize: "12px"}}>email is required*</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4 col-md-12 col-sm-12">
                                                            <div className="form-group">
                                                                <label htmlFor="">Profile picture</label>
                                                                <div className="profile_picture d-flex align-items-center">
                                                                    {
                                                                    getProfileDetails.avatar!==""&&
                                                                    <figure className="picture">
                                                                        <img src={file} alt="" className="img-fluid" />
                                                                    </figure>
                                                                    }
                                                                    {
                                                                    (getProfileDetails.avatar===''||getProfileDetails.avatar===undefined||getProfileDetails.avatar===null)&&
                                                                    <figure className="picture">
                                                                        <img src={Icons.UserPic} alt="" className="img-fluid" />
                                                                    </figure>
                                                                    }
                                                                    <div className="pic_content">
                                                                        <p>Profile picture should be in the standard format PNG or JPG are allowed.</p>
                                                                        <h6>Upload Profile Picture <img src={Icons.ArrowBlue} alt=""  className="img-fluid"/>  <input type="file" className="file_upload" accept="image/png, image/gif, image/jpeg" onChange={(e) => setAvatar(e.target.files, 'avatar')} /></h6>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    current1&&
                                                                <div className="submit_btn">
                                                                    <button type="button" className="btn btn_theme" onClick={nextButton}>Next</button>
                                                                </div>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    show_2 && (
                                        <div className="stepper_form_1 stepper_form_2">
                                            <div className="personal_ttl_form d-flex align-items-baseline">
                                                <figure className="back_arrow" onClick={backFunction}>
                                                    <img src={Icons.BackArrow} alt="" className="img-fluid"/>
                                                </figure>
                                                <div className="personal_ttl">
                                                    <h3>What are you preparing for</h3>
                                                </div>
                                            </div>
                                            <div className="form_submit_grp">
                                                <div className="row">
                                                    {
                                                        config&& config?.courses.map((o,i)=>(
                                                    <>
                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                            <div className="choose_course_wrapper d-flex align-items-center">
                                                                <div className="course_content d-flex align-items-center">
                                                                    <img className="choose_box" src={o.image}></img>
                                                                    <div className="course_body">
                                                                        <h6>{o.title}</h6>
                                                                        <p>{o.description}</p>
                                                                    </div>
                                                                </div>
                                                                <div className="checkbox">
                                                                    <div className="custom-control custom-checkbox">
                                                                        <input type="radio"   className="custom-control-input" checked={(o.title===getProfileDetails.preparingFor)?showcheck:''} id={`customCheck${i}`} name="example1" onChange={(e) => checkbox(e, o.title)} />
                                                                        <label className="custom-control-label" for={`customCheck${i}`}></label>
                                                                    </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>
                                                        ))
                                                    }
                                                    {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>Dental MDS/BDS</h6>
                                                                    <p>Dental Medical</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck1" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck1"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>NEET SS</h6>
                                                                    <p>Medical council of India, Speciality course</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck2" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck2"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>FMGE/NEXT</h6>
                                                                    <p>FMGE</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck3" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck3"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>Ayush</h6>
                                                                    <p>Ayurvedic, Yoga, Unani, Siddha and Homeopathy</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck1" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck1"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>MRCP</h6>
                                                                    <p>MRCP</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck2" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck2"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>USMLE</h6>
                                                                    <p>USMLE</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck3" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck3"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>Smart Medicine</h6>
                                                                    <p>Smart Medicine</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck1" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck1"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="choose_course_wrapper d-flex align-items-center">
                                                            <div className="course_content d-flex align-items-center">
                                                                <figure className="choose_box"></figure>
                                                                <div className="course_body">
                                                                    <h6>Smart Medicine</h6>
                                                                    <p>Smart Medicine</p>
                                                                </div>
                                                            </div>
                                                            <div className="checkbox">
                                                                <div className="custom-control custom-checkbox">
                                                                    <input type="checkbox" className="custom-control-input" id="customCheck2" name="example1" />
                                                                    <label className="custom-control-label" for="customCheck2"></label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> */}
                                                </div>
                                                {
                                                current2&&
                                                <div className="submit_btn text-right">
                                                    <button type="button" className="btn btn_theme" onClick={nextButton1}>Next</button>
                                                </div>
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                { show_3 && (
                                    <div className="stepper_form_1 stepper_form_2">
                                        <div className="personal_ttl_form d-flex align-items-baseline">
                                            <figure className="back_arrow" onClick={backFunction1}>
                                                <img src={Icons.BackArrow} alt="" className="img-fluid"/>
                                            </figure>
                                            <div className="personal_ttl">
                                                <h3>College Details</h3>
                                                <p>Please enter details</p>
                                            </div>
                                        </div>
                                        <div className="form_submit_grp">
                                            <form action="">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">Country</label>
                                                            <select  name="" id="" className="form-control" onChange={(event)=>selectCountry(event)}>
                                                            <option value="" selected>Select Country</option>
                                                                    {
                                                                        // selected={getProfileDetails.country === d._id}
                                                                country && country.data.result.countries.map((d, i) => (
                                                                    <option value={d._id} selected={getProfileDetails.country&&getProfileDetails.country === d._id}>{d.title}</option>
                                                                ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">State</label>
                                                            <select disabled={showstate} name="" id="" className="form-control" onChange={(event)=>selectState(event)}>
                                                            <option  value=""  selected>Select State</option>
                                                            {
                                                                // selected={getProfileDetails.collegeState === d._id}
                                                        state&& state.data && state.data.result.states.map((d, i) => (
                                                            <option  value={d._id}  selected={getProfileDetails.collegeState&&getProfileDetails.collegeState === d._id}>{d.title}</option>
                                                        ))
                                                        }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">City</label>
                                                            <select disabled={showcity} name="" id="" className="form-control" onChange={(event)=>selectCity(event)} >
                                                            <option value="" selected >Select City</option>
                                                                {
                                                                    // selected={getProfileDetails.collegeCity === d._id}
                                                        city&& city.data && city.data.result.city.map((d, i) => (
                                                            <option value={d._id} selected={getProfileDetails.collegeCity&&getProfileDetails.collegeCity === d._id} >{d.title}</option>
                                                        ))
                                                        }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">College name</label>
                                                            <select disabled={showcollege} name="" id="" className="form-control clg_selected" onChange={(e) => handleInputChange(e.target.value, 'collegeName')}>
                                                                <option value="" selected>Select College Name</option>
                                                                {
                                                                    // selected={getProfileDetails.collegeName === d._id}
                                                                (college&& college.data) && college.data.result.colleges.map((d, i) => (
                                                                    <option value={d._id} >{(d.title).slice(0,20)}...</option>
                                                                ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 col-md-4 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">College year</label>
                                                            <select disabled={showcollegeyear} name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'collegeYear')}>
                                                            <option value="" selected >Select Year</option>
                                                            {
                                                            (collegeYear&& collegeYear.data) && collegeYear.data.result.collegeYear.map((d, i) => (
                                                                <option value={d.title} selected={getProfileDetails.collegeYear === d.title}>{d.title}</option>
                                                            ))
                                                            }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-2 offset-lg-2 col-md-4 col-sm-12">
                                                        <div className="form-group">
                                                            <label htmlFor="">College batch</label>
                                                            <select disabled={showbatch} name="" id="" className="form-control" onChange={(e) => handleInputChange(e.target.value, 'batch')}>
                                                                <option value="" selected >Select Batch</option>
                                                                {
                                                                 config && config?.batches.map((d,i)=>(
                                                                <option value={d._id} selected={getProfileDetails.batch === d._id}>{d.year}</option>
                                                                 ))
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            <div className="accept_condition">
                                                <div className="custom-control custom-checkbox text-right">
                                                    <input type="checkbox" className="custom-control-input" id="accept" name="example1" checked={term} onChange={(e) => termAndCondition(e)}/>
                                                    <label className="custom-control-label" for="accept">By Signing-up you agree to the <a href="https://egurukulapp.com/TermsConditions" target="_blank" className="terms_accept">Terms and Conditions*</a> </label>
                                                </div>
                                            </div>
                                            {
                                             current3&&
                                            <div className="submit_btn text-right">
                                                <button type="submit" className="btn btn_theme" >Next</button>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                )
                                }
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
